import { createContext, FC, PropsWithChildren, useContext, useMemo } from "react";
import { createApiClient } from "../createApiClient";
import { apiCall } from "Helpers/ApiHelpers";
import { MoneyCheckerApiClient } from "ApiClient/moneyCheckerApiClient";

interface ApiClientContextValue {
    api: MoneyCheckerApiClient;
    apiCall: typeof apiCall;
}

const ApiClientContext = createContext<ApiClientContextValue | undefined>(undefined);

export const ApiClientProvider: FC<PropsWithChildren> = ({ children }) => {
    const value = useMemo<ApiClientContextValue>(() => ({
        api: createApiClient(),
        apiCall,
    }), []);

    return <ApiClientContext.Provider value={value}>{children}</ApiClientContext.Provider>;
};

export function useApiClient(): ApiClientContextValue {
    const value = useContext(ApiClientContext);
    if (!value) {
        throw new Error("useApiClient must be used within an ApiClientProvider.");
    }

    return value;
}